import { createApi } from '@reduxjs/toolkit/query/react';
import { createSentryFetchBaseQuery } from '../../../../app/api/sentryFetchBaseQuery';
import { CreateUserInput, CreateUserResponse, LoginInput, UserResponse } from '@shared/types/user.types';
import { getClientCredentials } from '../../../../app/shared/utils/cookie.utils';

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: createSentryFetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/auth/`,
    prepareHeaders: headers => {
      // Add authorization token for authenticated requests
      const token = localStorage.getItem('accessToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      // Add client credentials based on selected environment
      // (Login and signup don't need credentials, but other auth endpoints might)
      const environment = (localStorage.getItem('SELECTED_ENV') || 'DEV') as 'DEV' | 'PROD';
      const credentials = getClientCredentials(environment);
      const userId = localStorage.getItem('userId');
      if (credentials) {
        headers.set('X-Client-Id', credentials.clientId);
        if (credentials.clientSecret) {
          headers.set('X-Client-Secret', credentials.clientSecret);
        }
      }
      if (userId) {
        headers.set('X-User-Id', userId);
      }

      return headers;
    }
  }),
  endpoints: builder => ({
    // Login
    login: builder.mutation<UserResponse, LoginInput>({
      query: body => ({
        url: 'login',
        method: 'POST',
        body
      })
    }),

    // Sign Up
    createUser: builder.mutation<CreateUserResponse, CreateUserInput>({
      query: body => ({
        url: 'create-account',
        method: 'POST',
        body
      })
    }),

    // Fetch user profile by token or userId
    fetchUser: builder.query<UserResponse, void>({
      query: () => 'me'
    })
  })
});

export const { useLoginMutation, useCreateUserMutation, useFetchUserQuery } = userApi;
